module.exports = __webpack_public_path__ + "img/spinner.7be8933c.svg";